
import {defineComponent, onBeforeMount} from "vue";
import {RouteName} from "@/router/types";
import {useRouter} from "vue-router";

export default defineComponent({
  name: "DocumentationHomeManager",
  setup() {
    const router = useRouter()
    onBeforeMount(() => router.push({name: RouteName.DOCUMENTATION_USER_MANUAL}))
    return {RouteName};
  },
});
